import NavBar from "./Components/NavBar";
import ItemPanel from "./Components/ItemPanel";
import "./CSS/panel.css";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { useState, useEffect } from "react";
import { dbrealtime } from "./FirebaseConfig/firebase";
import { onValue, ref, set, update } from "firebase/database";

const MySwal = withReactContent(Swal);

function PanelCDA() {
  const navigate = useNavigate();

  //console.log("el dato local es" + localStorage.getItem("idLocal"));
  const [nombre, setNombre] = useState("");
  const [apellido, setApellido] = useState("");
  //const [ultimoNumero, setUltimoNumero] = useState();

  const elementos = [
    { nombre: "Eventos", imagen: "eventos" },
	//{ nombre: "Parrillas", imagen: "zonaparrillas" },
	{ nombre: "Colegiados", imagen: "colegiados" },
    { nombre: "Ingenieros", imagen: "usuarios" },
    { nombre: "Pagos", imagen: "pagos" },

  ];
  //cerrar panel
  const cerrar = () => {
    MySwal.fire({
      title: "Cerrar sesión?",
      text: "Desea cerrar sesión?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Si, Cerrar sesión",
    }).then((result) => {
      if (result.isConfirmed) {
        localStorage.setItem("idLocal", "");
        localStorage.setItem("nombreLocal", "");
        localStorage.setItem("apellidoLocal", "");
        navigate("../login");
      }
    });
  };

  useEffect(() => {
    if (localStorage.getItem("idLocal") == "") {
      const idLocal = localStorage.getItem("idLocal");
      console.log("NO ES USER");
      navigate("../login");
    } else {
      setNombre(localStorage.getItem("nombreLocal"));
      setApellido(localStorage.getItem("apellidoLocal"));
    }
	const fechaActual = new Date();
    const año = fechaActual.getFullYear();
    const mes = String(fechaActual.getMonth() + 1).padStart(2, "0");
    const dia = String(fechaActual.getDate()).padStart(2, "0");
    const fechaFormateada = `${año}-${mes}-${dia}`;
    localStorage.setItem("fechaParrilla", fechaFormateada);
	
	/*const query = ref(dbrealtime, "ultimonumero");

    return onValue(query, (snapshot) => {
      console.log("asssssssssss");

      const data = snapshot.val();
      console.log("adsada" + data);

      if (snapshot.exists()) {
        console.log(data);
        setUltimoNumero(data);
      }
    });*/
  }, []);
  return (
    <div className="panel">
      <NavBar
        titulo="BIENVENIDO"
        nombre={nombre + " " + apellido}
        imagen="salir"
        logoTitulo="hola"
        cerrar={cerrar}
      ></NavBar>
      <div className="panel-descrip">
        <strong>PANEL DE CONTROL </strong>
      </div>
      <div className="panel-grid-container">
        {elementos.map((item) => (
          <div
            className="panel-element"
            onClick={() => navigate("./" + item.imagen)}
          >
            <ItemPanel nombre={item.nombre} imagen={item.imagen} />
          </div>
        ))}
      </div>
    </div>
  );
}

export default PanelCDA;
